
namespace TabAurous.ProductDevelopment {
    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class DesignRequestDialog extends _Ext.ItemDialog<DesignRequestRow, any> {
        protected getFormKey() { return DesignRequestForm.formKey; }
        protected getLocalTextPrefix() { return DesignRequestRow.localTextPrefix; }
        protected getIdProperty() { return DesignRequestRow.idProperty; }
        protected getNameProperty() { return DesignRequestRow.nameProperty; }
        protected getService() { return DesignRequestService.baseUrl; }
        protected getDeletePermission() { return DesignRequestRow.deletePermission; }
        protected getInsertPermission() { return DesignRequestRow.insertPermission; }
        protected getUpdatePermission() { return DesignRequestRow.updatePermission; }
        protected useViewMode() { return true; }

        public form = new DesignRequestForm(this.idPrefix);
        protected get_ExtDialogOptions() {
            let opt = super.get_ExtDialogOptions();
            opt.AutoFitContentArea = false;
            opt.ShowDeleteButton = true;
            return opt;
        }

        // #region Constructor
        constructor() {
            super();
            var Config = Q.deepClone(q.DefualtEditorOptions);
            Config.height = 200;
            q.initDetailEditor(this, this.form.BOMDetails, Config);

            // #region UI
            //Make grid full width
            q.hideEditorLabel(this.form.ImageName);
            q.hideEditorLabel(this.form.Image1);
            q.hideEditorLabel(this.form.Image2);
            q.hideEditorLabel(this.form.Image3);
            // **** Assign Values to BOM and Labor Editor ****
            //Set Numeric Fields as Right Align
            q.setTextRightAlign(this.form.Pieces);
            q.setTextRightAlign(this.form.Weight);
            q.setTextRightAlign(this.form.NetWeight);
            q.setTextRightAlign(this.form.Iteration);
            // #endregion

            // #region Field Change Events


            this.form.PartyId.changeSelect2(e => {
                var party = this.form.PartyId.value;
                if (party != "") {
                    OMS.CustomerService.Retrieve({ EntityId: parseInt(party) }, response => {
                        this.form.LedgerName.value = response.Entity.LedgerName;
                        this.form.CustomerPrefix.value = response.Entity.CustomerPrefix;
                    }, { async: false })
                }
            })



            this.form.ProductTypeId.changeSelect2(e => {
                if (this.form.ProductTypeId.value != "") {
                    this.form.ItemTypeId.value = OMS.ProductTypeRow.getLookup().itemById[parseInt(this.form.ProductTypeId.value)].ItemTypeId;
                    this.entity.ItemTypeId = this.form.ItemTypeId.value;

                }
            });

            this.form.ProductCode.changeSelect2(e => {
                if (this.form.ProductCode.value != null) {
                    try {

                        let PrdId = 0;
                        var equalFilter = { "ProductCode": this.form.ProductCode.value.toUpperCase() };

                        OMS.ProductMasterService.List({ EqualityFilter: equalFilter, Take: 1 },
                            response => {
                                if (response.Entities.length > 0)
                                    PrdId = response.Entities[0].ProductId;
                            }, {
                            async: false
                        }
                        );

                        if (PrdId > 0) {
                            Q.notifyError("Duplicate Product Code " + this.form.ProductCode.value);
                            this.form.ProductCode.value = "";
                            this.form.ProductCode.element.focus();
                            return;
                        }
                        else {
                            this.form.ProductCode.value = this.form.ProductCode.value.toUpperCase();
                        }

                    }
                    catch (undefined) {

                    }
                }
            });

            this.form.DesignCode.changeSelect2(e => {
                var designcode = this.form.DesignCode.value;
                if (designcode != null) {
                    OMS.DesignEnquiryService.List({ DesignCode: designcode },
                        response => {
                            if (response.Entities != null && response.Entities.length == 1) {
                                let design = response.Entities[0];
                                this.form.DesignCode.value = design.DesignCode;
                                this.setdata(design);
                                this.unlockfields();
                            }
                            else if (response.Entities != null && response.Entities.length > 1) {

                                var grid = Common.DesignEnquirySelectGrid;
                                var options: _Ext.SelectGridFilters = {
                                    DesignCode: designcode
                                }
                                var pickerDialog = new _Ext.GridItemPickerDialog({
                                    gridType: grid, multiple: false, title: "Select Design", GridFilters: options
                                });


                                pickerDialog.onSuccess = (selectedItems: OMS.DesignRow[]) => {
                                    if (selectedItems.length > 0) {
                                        let design = selectedItems[0];
                                        this.form.DesignCode.value = design.DesignCode;
                                        this.setdata(design);
                                        this.unlockfields();
                                    }
                                }


                                pickerDialog.dialogOpen();
                            } else if (response.Entities.length == 0) {
                                q.showEditorToolbar(this.form.BOMDetails);

                            }
                        }, { async: false }
                    )
                }
            });

            //this.form.ProductCode.changeSelect2(e => {
            //    let productcode = this.form.ProductCode.value;
            //    if (productcode != null) {
            //        OMS.ProductMasterService.ProductsEnquiry({ IsEnquiry: true, ProductCode: productcode },
            //            response => {
            //                if (response.Entities != null && response.Entities.length == 1) {
            //                    let product = response.Entities[0];
            //                    this.form.ProductCode.value = product.ProductCode;
            //                    this.form.MetalId.value = product.MetalId.toString();
            //                    this.form.KaratId.value = product.KaratId.toString();
            //                    this.form.MetalColorId.value = product.MetalColorId.toString();
            //                    this.form.CategoryId.value = product.CategoryId.toString();
            //                    if (product.BOMDetails != null && product.BOMDetails.length > 0)
            //                        this.form.BOMDetails.setData(product.BOMDetails);
            //                }
            //                else if (response.Entities != null && response.Entities.length > 1) {
            //                    var grid = Common.ProductEnquirySelectGrid;
            //                    var options: _Ext.SelectGridFilters = {
            //                        Items: response.Entities,
            //                    }
            //                    var pickerDialog = new _Ext.GridItemPickerDialog({
            //                        gridType: grid, multiple: false, title: "Select Design", GridFilters: options
            //                    });


            //                    pickerDialog.onSuccess = (selectedItems: OMS.ProductMasterRow[]) => {
            //                        if (selectedItems.length > 0) {
            //                            let product = selectedItems[0];
            //                            this.form.DesignCode.value = product.ProductCode;
            //                            this.form.CategoryId.value = product.CategoryId.toString();
            //                            this.form.MetalId.value = product.ProductTypeId.toString();
            //                            this.form.KaratId.value = product.KaratId.toString();
            //                            this.form.MetalColorId.value = product.MetalColorId.toString();
            //                            if (product.BOMDetails != null && product.BOMDetails.length > 0)
            //                                this.form.BOMDetails.setData(product.BOMDetails);
            //                        }
            //                    }


            //                    pickerDialog.dialogOpen();
            //                }
            //            }, { async: false })
            //    }
            //})
            var skuEditor: JQuery = this.form.ProductCode.element.closest(".editor");
            skuEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(skuEditor)
                .click((e) => { this.skuSearchClick(e) }
                );
            this.form.CategoryId.changeSelect2(e => {
                if (this.form.CategoryId.value != "") {
                    OMS.CategoryMasterService.Retrieve({ EntityId: this.form.CategoryId.value }, response => {
                        this.form.CategoryCode.value = response.Entity.CategoryCode;
                        if (response.Entity.IsSizeApplicable)
                            q.showAndSetRequiredField(this.form.ProductSizeId);
                        else {
                            q.hideField(this.form.ProductSizeId);
                            q.showAndDisableField(this.form.ProductSizeId);
                        }
                    }, { async: false });
                }
            })

            this.form.IsSmartStone.changeSelect2(e => {
                if (this.form.IsSmartStone.value)
                    q.showAndEnableField(this.form.StoneSizeId);
                else
                    q.hideField(this.form.StoneSizeId);
            });

            //this.form.HasBom.changeSelect2(e => {
            //    var self = this;
            //    if (this.form.BOMDetails.getItems().length > 0) {
            //        q.information(q.text("Message.Voucher.ReadOnly", "Are you sure?"), q.text("Message.Voucher.ReadOnlyInfo", "This will remove all components"), true, function () { self.removeBOM(); });
            //    }
            //    ItemFieldHelper.PurchaseItemFields(this, this.ItemMaster.form.VoucherTypeId.value);
            //})

            var min = 0, max = 0, std = 0;
            this.form.KaratId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.KaratId.value)) {

                    var KaratId = Q.toId(this.form.KaratId.value);
                    var purity: OMS.AttributeMasterRow;
                    OMS.AttributeMasterService.Retrieve({ EntityId: parseInt(KaratId) }, response => {
                        purity = response.Entity;
                        this.form.KaratName.value = response.Entity.AttributeName;

                    }, { async: false });
                    //var min = purity.MinPurity;
                    //var max = purity.MaxPurity;
                    //var std = purity.StdPurity;
                    //q.showAndSetRequiredField(this.form.Purity);
                    //this.form.Purity.value = std;
                    //this.form.Purity.value = std;

                    //this.form.UnitRate.value = RateHelper.GetMetalRate(parseInt(this.form.ProductTypeId.value), parseInt(this.form.KaratId.value), false, this.form.TransDate.valueAsDate) / this.ExchangeRate;
                }

            });

            this.form.MetalId.changeSelect2(e => {
                if (!Q.isEmptyOrNull(this.form.MetalId.value)) {
                    q.showAndSetRequiredField(this.form.KaratId);
                    this.form.KaratId.cascadeField = "Num1";
                    this.form.KaratId.cascadeValue = this.form.MetalId.value;
                }
            });
            this.form.MappingId.changeSelect2(e => {
                var mappingid = this.form.MappingId.value;
                if (mappingid != null && mappingid != "") {
                    OMS.ColorQualityMappingService.Retrieve({ EntityId: mappingid }, response => { this.form.Code.value = response.Entity.Code; }, { async: false });
                }
            });

            this.form.MetalColorId.changeSelect2(e => {
                var metalcolorid = this.form.MetalColorId.value;
                if (metalcolorid != null && metalcolorid != "") {
                    OMS.AttributeMasterService.Retrieve({ EntityId: metalcolorid }, response => { this.form.MetalColorName.value = response.Entity.AttributeName; }, { async: false });
                }
            });
            this.form.ProductSizeId.changeSelect2(e => {
                var productsizeid = this.form.ProductSizeId.value;
                if (productsizeid != null && productsizeid != "") {
                    OMS.ProductSizeMasterService.Retrieve({ EntityId: productsizeid }, response => { this.form.ProductSizeName.value = response.Entity.ProductSizeCode; }, { async: false });
                }
            });


            // #endregion

            //*** BOM row add Edit Delete Event ****

            var fieldEditor: JQuery = this.form.DesignCode.element.closest(".editor");
            fieldEditor.addClass("has-inplace-button");
            $(' <button type="button">...</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Search')
                .insertAfter(fieldEditor)
                .click((e) => { this.inplaceSearchClick(e) }
                );

            var cancel: JQuery = this.form.DesignCode.element.closest(".editor");
            cancel.addClass("has-inplace-button");
            $(' <button type="button">X</button>')
                .addClass('inplace-button')
                .addClass('inplace-search edit')
                .attr('title', 'Cancel')
                .insertAfter(cancel)
                .click((e) => { this.cancel(e) }
                );

        }
        protected inplaceSearchClick(e: any): void {
            if (!this.isViewMode()) {

                var grid = OMS.DesignGrid;

                var pickerDialog = new _Ext.GridItemPickerDialog({
                    gridType: grid, multiple: false, title: "Select Design"
                });

                pickerDialog.onSuccess = (selectedItems: OMS.DesignRow[]) => {

                    if (selectedItems.length > 0) {
                        let design = selectedItems[0];
                        this.set_entity(design);
                        var x = this.entity;
                        this.form.DesignId.value = design.DesignId.toString();
                        this.form.DesignCode.value = design.DesignCode;
                        this.setdata(design);
                    }
                    this.unlockfields();
                }
                pickerDialog.dialogOpen();

            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }
        // #endregion


        protected onDialogOpen() {
            super.onDialogOpen();
            if (this.form.IsSmartStone.value)
                q.showAndEnableField(this.form.StoneSizeId);
            else
                q.hideField(this.form.StoneSizeId);

        }
        protected skuSearchClick(e: any): void {
            var T = this.isViewMode();

            if (!this.isViewMode()) {
                var grid = Common.ProductSKUSelectGrid;
                var customerid = this.form.PartyId.value;
                if (customerid != "") {
                    var filters: _Ext.SelectGridFilters = {
                        CustomerId: parseInt(customerid)
                    };
                    var pickerDialog = new _Ext.GridItemPickerDialog({
                        gridType: grid, multiple: false, title: "Select Design", GridFilters: filters
                    });

                    pickerDialog.onSuccess = (selectedItems: OMS.ProductPartyDetailsRow[]) => {

                        if (selectedItems.length > 0) {
                            var productid = selectedItems[0].ProductId;
                            let product: OMS.ProductMasterRow;
                            OMS.ProductMasterService.Retrieve({ EntityId: productid },
                                response => { product = response.Entity }, { async: false });
                            this.form.ProductId.value = product.ProductId.toString();
                            this.form.CategoryId.value = product.CategoryId.toString();
                            this.form.MappingId.value = product.MappingId.toString();
                            this.form.ProductSizeId.value = product.ProductSizeId.toString();
                            this.form.ProductCode.value = product.ProductCode;
                            this.form.SKU.value = product.ProductCode;
                            var stonebom = [];
                            var bom = product.BOMDetails;
                            for (var i = 0; i < bom.length; i++) {
                                var _bom = bom[i];
                                if (_bom.ItemTypeId == 104) {
                                    this.form.KaratId.value = _bom.KaratId.toString();
                                    this.form.MetalColorId.value = _bom.MetalColorId.toString();
                                    this.form.MetalId.value = _bom.ProductTypeId.toString();

                                }
                                else if (_bom.ItemTypeId == 105) {
                                    stonebom.push(_bom);
                                }

                            }
                            if (stonebom.length > 0) {
                                this.form.BOMDetails.setData(stonebom);
                            }
                            this.lockfields();
                        }
                    }
                    pickerDialog.dialogOpen();
                } else {
                    q.Alert("View Mode", "Please Select Customer", 2000, false);

                }
            }
            else {
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
            }
        }

        protected cancel(e: any): void {
            if (!this.isViewMode()) {
                this.form.DesignCode.value = "";
                this.form.ProductCode.value = "";

            }
            else
                q.Alert("View Mode", "Can not make changes in view mode", 2000, false);
        }
        public unlockfields() {

            q.showAndEnableField(this.form.CategoryId);
            q.showAndEnableField(this.form.KaratId);
            q.showAndEnableField(this.form.MetalColorId);
            q.showAndEnableField(this.form.MetalId);
            q.showAndEnableField(this.form.MappingId);
            q.showAndEnableField(this.form.ProductSizeId);

            q.hideField(this.form.ProductCode);
        }
        public lockfields() {
            q.hideField(this.form.DesignCode);
            q.showAndDisableField(this.form.DesignCode);
            q.hideField(this.form.ProductCode);
            q.showAndDisableField(this.form.ProductCode);

            q.showAndDisableField(this.form.CategoryId);
            q.showAndDisableField(this.form.KaratId);
            q.showAndDisableField(this.form.MetalColorId);
            q.showAndDisableField(this.form.MetalId);
            q.showAndDisableField(this.form.MappingId);
            q.showAndDisableField(this.form.ProductSizeId);
            q.hideEditorLabel(this.form.BOMDetails);


        }
        setdata(item: any) {
            let Entities: OMS.DesignRow[];
            if (item.DesignId != null) {
                OMS.DesignService.DesignList({ DesignCode: item.DesignCode },
                    response => Entities = response.Entities, { async: false });
            }

            let _iteration = Math.max.apply(Math, Entities.map(function (o) { return o.Iteration; }))
            _iteration += 1;
            let iteration = _iteration < 10 ? "0" + _iteration : _iteration.toString();
            this.form.Iteration.value = iteration;
            this.form.DesignCode.value = item.DesignCode;
            this.form.DesignName.value = item.DesignName;
            this.form.ItemTypeId.value = item.ItemTypeId;
            this.form.ProductTypeId.value = item.ProductTypeId;
            this.form.MetalColorId.value = item.MetalColorId;
            this.form.CategoryId.value = item.CategoryId;
            this.form.AttributeId.value = item.AttributeId;
            this.form.Attribute.value = item.Attribute;
            this.form.HasBom.value = item.HasBom;
            this.form.MetalId.value = item.MetalId;
            this.form.KaratId.value = item.KaratId;
            this.form.MappingId.value = item.MappingId == null ? "0" : item.MappingId.toString();

            this.form.ProductSizeId.value = item.ProductSizeId == null ? "0" : item.ProductSizeId.toString();

            this.form.KaratName.value = item.KaratName;
            this.form.MetalColorName.value = item.MetalColorName.toString();
            this.form.Code.value = item.MappingCode == null ? "NA" : item.MappingCode.toString();
            this.form.ProductSizeName.value = item.ProductSizeName.toString();
            this.form.CategoryCode.value = item.CategoryCode.toString();
            this.form.ZProofId.value = item.ZProofId;
            if (item.BOMDetails != null && item.BOMDetails.length > 0)
                this.form.BOMDetails.setData(item.BOMDetails);
        }
        protected validateBeforeSave() {
            let returnvalue = super.validateBeforeSave();
            let image1 = this.form.ImageName.value == null ? "" : this.form.ImageName.value.Filename;

            if (image1 == "") {
                q.Alert('', 'Image is required!', 1999, false);
                returnvalue = false;
            }
            return returnvalue;
        }

        onSaveSuccess(response) {
            super.onSaveSuccess(response);

            DesignRequestService.SubmitQuotation({ TransId: response.EntityId },
                response => {
                    if (response.Error == null)
                        Q.notifySuccess("Saved and Ziflow Proof created!");
                    else
                        Q.notifyWarning("Error while creating Proof, resubmit document");
                    }

            );

        }

        protected getToolbarButtons(): Serenity.ToolButton[] {
            let btns = super.getToolbarButtons();

            //Submit Button
            btns.push({
                title: 'Submit',
                cssClass: 'export-Submit-button',
                icon: 'fa fa-upload',
                onClick: () => {
                    DesignRequestService.SubmitQuotation({ TransId: this.entity.TransItemId },
                        response => {
                            if (response.EntityId == this.entity.TransItemId) {
                                q.success('', 'Quotation Submitted', 2999, true);
                                this.dialogClose();

                            }

                        }, { async: true })

                }
            });

            return btns;
        }
    }
}
